module.exports = __webpack_public_path__ + "media/src/images/received_gifts/bnr-login-saveimg-fe21b8b3677e9949781f62371d012936.svg";